<h1 mat-dialog-title>{{data.title}}</h1>
<div mat-dialog-content>
    <div class="confirm-message">{{data.message}}</div>
</div>
<mat-dialog-actions align="end">
    <button mat-button [mat-dialog-close]="false">Cancel</button>
    <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Ok</button>
</mat-dialog-actions>